import store from '../../store/index';
import captureRenderBlockingException from '../../tracking/helpers/captureRenderBlockingException';
import tagRecordings from '../../tracking/hotjar/tagRecordings';

export default async function beforeEnterAccountHome(to, from, next) {
  try {
    const completed = await store.dispatch('hasAccountHome');
    if (!completed) {
      tagRecordings(['cannot_enter_account_home']);
      window.location.replace('/account_home?f=1');
    } else {
      next();
    }
  } catch (e) {
    const extras = {
      loanApplication: store.state.loanApplication,
    };
    captureRenderBlockingException(e, extras);
    window.location.replace('/account_home?f=1');
  } finally {
    store.dispatch('setAwaitingNavigation', false);
  }
}
